import { useFlotasStore, useGeographyStore } from "@/store/erp";
import { usePlanStore } from "@/store/erp/system-settings/plan.store";
import { useTypeInstalation } from "@/store/erp/system-settings/type-instalation";
import { useEffect } from "react";
import { Outlet } from "react-router-dom";

export default function SoportePymesModule() {

  const getZones = useGeographyStore(s => s.getZones);
  const getSectors = useGeographyStore(s => s.getSectors);
  const getPlans = usePlanStore(s => s.getPlans);
  const getFlotaPyme = useFlotasStore(s => s.getFlotaPyme);
  const getTypeInstalation = useTypeInstalation(s => s.getTypeInstalation);

  useEffect(() => {
    (async () => {
      const results = await Promise.allSettled([
        getFlotaPyme({
          page_size: 1000,
          estado: true,
          es_pyme: true
        }),
        getZones({
          page_size: 1000,
          estado: true,
        }),
        getSectors({
          page_size: 1000,
          estado: true,
        }),
        getPlans({
          page_size: 1000,
          estado: true,
        }),
        getTypeInstalation({
          page_size: 1000,
          estado: true,
        }),
      ]);
      results.forEach((result, index) => {
        if (result.status === 'rejected') {
          console.error(`Data load failed at position ${index}:`, result.reason);
        }
      });
    })();
  }, []);

  return <Outlet />

}